import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
  useReducer,
} from "react";
import { AppContext } from "../../ContextAPI/AppProvider";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  baseApiURL,
  cultures,
  bookCategoryId,
  paintCategoryId,
  photographCategoryId,
  publicationsTypes,
} from "../../Helpers/Constant";
import { useLocalStorage } from "../../Helpers/useLocalStorage";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ShopHeader = (props) => {
  
  let navigate = useNavigate();
  const { dirimart, translation, setDirimartData } = useContext(AppContext);
  const [cartItems, setCartItems] = useState();
  const [langId, setLangId] = useLocalStorage("langId", null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [previousCartItems, setPreviousCartItems] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const isMounted = useRef(false);

  const _changeLang = (langId) => {
    setLangId(langId);
    let dirimartData = { ...dirimart };
    dirimartData.langId = langId;
    dirimart.culture = cultures[langId];
    setDirimartData(dirimartData);
  };

  useEffect(() => {
  
    (async () => {
      const localStorageItems = await JSON.parse(
        localStorage.getItem("cartItems")
      );
      if (localStorageItems) {
        await setCartItems(localStorageItems);
        let itemCount = 0;
        localStorageItems.forEach((item) => {
          itemCount += item.quantity;
        });

        await setItemCount(itemCount);
      }
    })();
  }, [dirimart, localStorage.getItem("cartItems")]);

 



  return (
    <>
    <div>{props.totalQuantity}</div>
      <div className="header shopHeader">
        <input id="navToggle" type="checkbox" />
        <Link to={"/Shop"}>
          <svg
            className="headerLogo"
            width="309"
            height="36"
            viewBox="0 0 309 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1600_2823)">
              <path
                d="M37.543 35.5012H42.1405V16.799H37.543V35.5012ZM37.543 12.9338H42.1405V0.554688H37.543V12.9338Z"
                fill="#25282E"
              ></path>
              <path
                d="M87.6797 35.5012H92.2772V16.799H87.6797V35.5012ZM87.6797 12.9338H92.2772V0.554688H87.6797V12.9338Z"
                fill="#25282E"
              ></path>
              <path
                d="M165.088 28.6603L167.474 35.4822H172.263L169.825 28.6603H165.088ZM155.092 0.553433L148.945 16.9758H153.577L157.408 6.2888L162.389 20.841H147.43L141.996 35.4466H146.837L150.651 24.7595H168.38L159.672 0.5H154.935L155.092 0.553433Z"
                fill="#25282E"
              ></path>
              <path
                d="M212.373 4.6145H218.834V0.5H212.355V4.6145H212.373ZM222.63 0.5V35.5H227.228V4.6145H237.433V0.5H222.63Z"
                fill="#25282E"
              ></path>
              <path
                d="M184.454 4.4195V12.9335H179.996V0.554338H192.709C194.681 0.506868 196.655 0.608099 198.613 0.85716C200.909 1.17275 203.002 2.36981 204.467 4.20561C205.932 6.0414 206.659 8.37845 206.502 10.7426C206.502 16.193 203.82 19.4526 198.421 20.3432C196.715 20.5415 195 20.6425 193.284 20.6459H184.472V35.4831H179.996V16.7808H193.493C194.888 16.8291 196.284 16.7155 197.655 16.4424C198.918 16.2048 200.052 15.4994 200.839 14.4611C201.626 13.4229 202.011 12.1245 201.922 10.8139C201.97 9.89248 201.812 8.97185 201.459 8.12274C201.106 7.27362 200.567 6.51861 199.884 5.91568C199.022 5.20215 197.987 4.74055 196.889 4.5798C195.679 4.46267 194.464 4.41506 193.249 4.43728H184.437L184.454 4.4195ZM201.016 24.5111L207.982 35.5009H202.566L195.687 24.5111H201.033H201.016Z"
                fill="#25282E"
              ></path>
              <path
                d="M8.86061 4.66919H5.0816V31.4936H8.86061V35.5012H0.449219V0.554688H8.86061V4.66919ZM12.6397 31.3867C14.7304 31.3933 16.7958 30.9184 18.6827 29.9974C22.1657 28.0144 23.9072 24.0246 23.9072 18.028C23.9072 10.9627 21.5387 6.68788 16.8018 5.20357C15.4582 4.85282 14.0785 4.6674 12.6919 4.65136V0.590291C14.493 0.581558 16.2902 0.760633 18.0557 1.12468C20.4495 1.72448 22.6178 3.0315 24.2903 4.88292C27.1347 7.98216 28.5569 12.3698 28.5569 18.0458C28.5569 24.173 26.9605 28.7566 23.7678 31.7964C22.0378 33.4217 19.916 34.5467 17.6203 35.056C15.996 35.3713 14.3451 35.5205 12.6919 35.5012V31.458L12.6397 31.3867Z"
                fill="#25282E"
              ></path>
              <path
                d="M108.474 12.9338L106.158 6.64631L106.645 35.5012H102.152V0.554688H108.004L112.532 12.9338H108.422H108.474ZM127.178 16.799L120.212 35.5012H116.729L109.867 16.799H113.977L118.522 29.2671L123.103 16.799H127.16H127.178ZM129.093 0.572517H134.945V35.5012H130.434L131.061 6.20102L128.588 12.9338H124.531L129.093 0.572517Z"
                fill="#25282E"
              ></path>
              <path
                d="M79.0097 10.7611C79.1577 12.4358 78.8246 14.1183 78.0513 15.6022C77.2779 17.086 76.0979 18.3068 74.656 19.1148L72.3573 15.5524C73.0664 15.0168 73.6314 14.3064 73.9999 13.4873C74.3683 12.6683 74.5282 11.7672 74.4645 10.8679C74.5134 9.94652 74.3551 9.02589 74.0019 8.17677C73.6487 7.32766 73.1099 6.57265 72.4269 5.96971C71.5664 5.2531 70.5305 4.7911 69.4315 4.63384C68.2279 4.51382 67.0184 4.46621 65.8092 4.49131H56.9973V16.8705H66.0356C67.0283 16.8705 67.8816 16.8705 68.613 16.7636L80.5075 35.5728H75.0914L65.8092 20.7356H52.5564V0.572769H65.2345C67.207 0.528087 69.18 0.629253 71.1382 0.875538C72.6948 1.09316 74.1735 1.70545 75.4397 2.65671C76.6343 3.60167 77.5855 4.83048 78.2106 6.23655C78.8358 7.64262 79.1161 9.18346 79.0272 10.7254L79.0097 10.7611ZM56.9973 35.5015H52.5391V24.5117H56.9973V35.5015Z"
                fill="#25282E"
              ></path>
            </g>
            <rect x="245.449" y="8.5" width="1" height="19" fill="black"></rect>
            <path
              d="M259.025 23.6803C258.428 23.6803 257.852 23.6163 257.297 23.4883C256.743 23.371 256.252 23.179 255.825 22.9123C255.399 22.635 255.063 22.2883 254.817 21.8723C254.572 21.4456 254.449 20.939 254.449 20.3523C254.449 20.2883 254.449 20.2296 254.449 20.1763C254.46 20.1123 254.465 20.059 254.465 20.0163H256.257C256.257 20.0483 256.252 20.0963 256.241 20.1603C256.241 20.2243 256.241 20.2776 256.241 20.3203C256.241 20.715 256.359 21.051 256.593 21.3283C256.828 21.6056 257.153 21.8136 257.569 21.9523C257.996 22.091 258.481 22.1603 259.025 22.1603C259.324 22.1603 259.612 22.1443 259.889 22.1123C260.167 22.0696 260.417 22.011 260.641 21.9363C260.876 21.851 261.079 21.7496 261.249 21.6323C261.42 21.5043 261.553 21.355 261.649 21.1843C261.745 21.0136 261.793 20.8163 261.793 20.5923C261.793 20.251 261.692 19.9683 261.489 19.7443C261.297 19.5203 261.031 19.3336 260.689 19.1843C260.359 19.035 259.98 18.9016 259.553 18.7843C259.137 18.667 258.705 18.5496 258.257 18.4323C257.809 18.315 257.372 18.1763 256.945 18.0163C256.529 17.8563 256.151 17.6643 255.809 17.4403C255.479 17.2056 255.212 16.9176 255.009 16.5763C254.817 16.2243 254.721 15.7976 254.721 15.2963C254.721 14.8163 254.823 14.3896 255.025 14.0163C255.228 13.643 255.521 13.3336 255.905 13.0883C256.289 12.8323 256.748 12.6403 257.281 12.5123C257.815 12.3843 258.417 12.3203 259.089 12.3203C259.665 12.3203 260.209 12.3843 260.721 12.5123C261.233 12.6296 261.681 12.8163 262.065 13.0723C262.449 13.3283 262.748 13.6536 262.961 14.0483C263.185 14.443 263.297 14.9123 263.297 15.4563V15.6483H261.521V15.4403C261.521 15.099 261.42 14.811 261.217 14.5763C261.015 14.3416 260.732 14.1603 260.369 14.0323C260.007 13.9043 259.585 13.8403 259.105 13.8403C258.54 13.8403 258.065 13.899 257.681 14.0163C257.297 14.123 257.004 14.2776 256.801 14.4803C256.609 14.6723 256.513 14.907 256.513 15.1843C256.513 15.4936 256.615 15.7496 256.817 15.9523C257.02 16.1443 257.287 16.3096 257.617 16.4483C257.959 16.587 258.337 16.715 258.753 16.8323C259.18 16.939 259.612 17.0563 260.049 17.1843C260.497 17.3016 260.929 17.4403 261.345 17.6003C261.772 17.7603 262.151 17.9576 262.481 18.1923C262.823 18.427 263.095 18.7203 263.297 19.0723C263.5 19.4136 263.601 19.835 263.601 20.3363C263.601 21.1256 263.404 21.771 263.009 22.2723C262.615 22.763 262.071 23.1203 261.377 23.3443C260.695 23.5683 259.911 23.6803 259.025 23.6803Z"
              fill="black"
            ></path>
            <path
              d="M268.88 23.4883V12.5123H270.672V17.1043H276.24V12.5123H278.032V23.4883H276.24V18.6403H270.672V23.4883H268.88Z"
              fill="black"
            ></path>
            <path
              d="M288.806 23.6803C287.675 23.6803 286.694 23.4723 285.862 23.0563C285.041 22.6403 284.406 22.011 283.958 21.1683C283.521 20.3256 283.302 19.2696 283.302 18.0003C283.302 16.7203 283.521 15.6643 283.958 14.8323C284.406 13.9896 285.041 13.3603 285.862 12.9443C286.694 12.5283 287.675 12.3203 288.806 12.3203C289.958 12.3203 290.945 12.5283 291.766 12.9443C292.587 13.3603 293.217 13.9896 293.654 14.8323C294.102 15.6643 294.326 16.7203 294.326 18.0003C294.326 19.2696 294.102 20.3256 293.654 21.1683C293.217 22.011 292.587 22.6403 291.766 23.0563C290.945 23.4723 289.958 23.6803 288.806 23.6803ZM288.806 22.1603C289.393 22.1603 289.91 22.0803 290.358 21.9203C290.817 21.7603 291.201 21.515 291.51 21.1843C291.83 20.8536 292.07 20.4376 292.23 19.9363C292.401 19.435 292.486 18.8536 292.486 18.1923V17.8403C292.486 17.1576 292.401 16.5656 292.23 16.0643C292.07 15.563 291.83 15.147 291.51 14.8163C291.201 14.4856 290.817 14.2403 290.358 14.0803C289.91 13.9203 289.393 13.8403 288.806 13.8403C288.23 13.8403 287.713 13.9203 287.254 14.0803C286.806 14.2403 286.422 14.4856 286.102 14.8163C285.793 15.147 285.558 15.563 285.398 16.0643C285.238 16.5656 285.158 17.1576 285.158 17.8403V18.1923C285.158 18.8536 285.238 19.435 285.398 19.9363C285.558 20.4376 285.793 20.8536 286.102 21.1843C286.422 21.515 286.806 21.7603 287.254 21.9203C287.713 22.0803 288.23 22.1603 288.806 22.1603Z"
              fill="black"
            ></path>
            <path
              d="M299.592 23.4883V12.5123H305.064C305.843 12.5123 306.488 12.6563 307 12.9443C307.512 13.2323 307.896 13.6323 308.152 14.1443C308.419 14.6456 308.552 15.243 308.552 15.9363C308.552 16.6296 308.414 17.243 308.136 17.7763C307.859 18.299 307.454 18.7043 306.92 18.9923C306.398 19.2803 305.758 19.4243 305 19.4243H301.384V23.4883H299.592ZM301.384 17.8883H304.92C305.486 17.8883 305.928 17.7176 306.248 17.3763C306.579 17.035 306.744 16.5603 306.744 15.9523C306.744 15.547 306.675 15.2056 306.536 14.9283C306.398 14.6403 306.195 14.4216 305.928 14.2723C305.662 14.123 305.326 14.0483 304.92 14.0483H301.384V17.8883Z"
              fill="black"
            ></path>
            <defs>
              <clipPath id="clip0_1600_2823">
                <rect
                  width="237"
                  height="35"
                  fill="white"
                  transform="translate(0.449219 0.5)"
                ></rect>
              </clipPath>
            </defs>
          </svg>
        </Link>
        <ul className="fixedMenu">
          <li className="dropdown">
            <Link
              to={"/Shop/Books/" + bookCategoryId}
              className="followDropdown"
            >
              {translation.Shop.book}
            </Link>

            <div className="dropdownContent">
              <Link
                to={
                  "/Shop/Books/" +
                  bookCategoryId +
                  "/ArtistBooks/" +
                  publicationsTypes.ArtistBookss
                }
              >
                {translation.Shop.artistbooks}
              </Link>

              <Link
                to={
                  "/Shop/Books/" +
                  bookCategoryId +
                  "/ArtistCatalogs/" +
                  publicationsTypes.ArtistCatalogs
                }
              >
                {translation.Shop.artistcatalog}
              </Link>
              <Link
                to={
                  "/Shop/Books/" +
                  bookCategoryId +
                  "/Biography/" +
                  publicationsTypes.Biographies
                }
              >
                {translation.Shop.biography}
              </Link>
        <Link
        to={ "/Shop/Books/" +
        bookCategoryId +
        "/Monographs/" +
        publicationsTypes.Monographs}
        >
            {translation.Shop.monograph}
        </Link>
            </div>
          </li>
          <li>
        <Link
        to={"/Shop/Photography/" + photographCategoryId}>
              {translation.Shop.photograph}
        </Link>
          </li>
          <li>
         <Link to={"/Shop/Painting/" + paintCategoryId}>
         {translation.Shop.painting}
         </Link>
          </li>
          <li>
            <a
              onClick={() =>
                !dirimart.langButtonDisabled
                  ? _changeLang(dirimart.langId == 1055 ? 1033 : 1055)
                  : null
              }
              disabled={dirimart.langButtonDisabled}
              className={dirimart.langButtonDisabled ? "disabled" : ""}
            >
              {dirimart.langId == 1055 ? "EN" : "TR"}
            </a>
          </li>
          <li>
         <Link to={"/Shop/Cart/"} className="hasBadgeItem">
         {translation.Shop.cart}{" "}
              <span className="badge">{itemCount}</span>
         </Link>
          </li>
          <li>
            <div className="socialMediaIcons">
              <svg
                width="25"
                height="21"
                viewBox="0 0 25 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.0156 5.71484C22.9531 5.01172 23.7969 4.16797 24.4531 3.18359C23.6094 3.55859 22.625 3.83984 21.6406 3.93359C22.6719 3.32422 23.4219 2.38672 23.7969 1.21484C22.8594 1.77734 21.7812 2.19922 20.7031 2.43359C19.7656 1.44922 18.5 0.886719 17.0938 0.886719C14.375 0.886719 12.1719 3.08984 12.1719 5.80859C12.1719 6.18359 12.2188 6.55859 12.3125 6.93359C8.23438 6.69922 4.57812 4.73047 2.14062 1.77734C1.71875 2.48047 1.48438 3.32422 1.48438 4.26172C1.48438 5.94922 2.32812 7.44922 3.6875 8.33984C2.89062 8.29297 2.09375 8.10547 1.4375 7.73047V7.77734C1.4375 10.168 3.125 12.1367 5.375 12.6055C5 12.6992 4.53125 12.793 4.10938 12.793C3.78125 12.793 3.5 12.7461 3.17188 12.6992C3.78125 14.668 5.60938 16.0742 7.76562 16.1211C6.07812 17.4336 3.96875 18.2305 1.67188 18.2305C1.25 18.2305 0.875 18.1836 0.5 18.1367C2.65625 19.543 5.23438 20.3398 8.04688 20.3398C17.0938 20.3398 22.0156 12.8867 22.0156 6.37109C22.0156 6.13672 22.0156 5.94922 22.0156 5.71484Z"
                  fill="#25282E"
                ></path>
              </svg>
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7031 12.6133C23.7031 6.19141 18.5 0.988281 12.0781 0.988281C5.65625 0.988281 0.453125 6.19141 0.453125 12.6133C0.453125 17.582 3.5 21.7539 7.8125 23.4414C7.71875 22.5508 7.625 21.1445 7.85938 20.1133C8.09375 19.2227 9.21875 14.3477 9.21875 14.3477C9.21875 14.3477 8.89062 13.6445 8.89062 12.6133C8.89062 11.0195 9.82812 9.80078 11 9.80078C11.9844 9.80078 12.4531 10.5508 12.4531 11.4414C12.4531 12.4258 11.7969 13.9258 11.4688 15.332C11.2344 16.457 12.0781 17.3945 13.2031 17.3945C15.2656 17.3945 16.8594 15.2383 16.8594 12.0977C16.8594 9.28516 14.8438 7.36328 12.0312 7.36328C8.70312 7.36328 6.78125 9.84766 6.78125 12.3789C6.78125 13.4102 7.15625 14.4883 7.625 15.0508C7.71875 15.1445 7.71875 15.2852 7.71875 15.3789C7.625 15.7539 7.39062 16.5508 7.39062 16.6914C7.34375 16.9258 7.20312 16.9727 6.96875 16.8789C5.51562 16.1758 4.625 14.0664 4.625 12.332C4.625 8.67578 7.29688 5.30078 12.3125 5.30078C16.3438 5.30078 19.4844 8.20703 19.4844 12.0508C19.4844 16.0352 16.9531 19.2695 13.4375 19.2695C12.2656 19.2695 11.1406 18.6602 10.7656 17.9102C10.7656 17.9102 10.2031 20.1602 10.0625 20.6758C9.78125 21.707 9.07812 22.9727 8.60938 23.7227C9.6875 24.0977 10.8594 24.2383 12.0781 24.2383C18.5 24.2383 23.7031 19.0352 23.7031 12.6133Z"
                  fill="#25282E"
                ></path>
              </svg>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.9531 11.6836C23.9531 5.26172 18.75 0.0585938 12.3281 0.0585938C5.90625 0.0585938 0.703125 5.26172 0.703125 11.6836C0.703125 17.4961 4.92188 22.3242 10.5 23.168V15.0586H7.54688V11.6836H10.5V9.15234C10.5 6.24609 12.2344 4.60547 14.8594 4.60547C16.1719 4.60547 17.4844 4.83984 17.4844 4.83984V7.69922H16.0312C14.5781 7.69922 14.1094 8.58984 14.1094 9.52734V11.6836H17.3438L16.8281 15.0586H14.1094V23.168C19.6875 22.3242 23.9531 17.4961 23.9531 11.6836Z"
                  fill="#25282E"
                ></path>
              </svg>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.4766 5.19922C8.47656 5.19922 6.08594 7.63672 6.08594 10.5898C6.08594 13.5898 8.47656 15.9805 11.4766 15.9805C14.4297 15.9805 16.8672 13.5898 16.8672 10.5898C16.8672 7.63672 14.4297 5.19922 11.4766 5.19922ZM11.4766 14.1055C9.55469 14.1055 7.96094 12.5586 7.96094 10.5898C7.96094 8.66797 9.50781 7.12109 11.4766 7.12109C13.3984 7.12109 14.9453 8.66797 14.9453 10.5898C14.9453 12.5586 13.3984 14.1055 11.4766 14.1055ZM18.3203 5.01172C18.3203 4.30859 17.7578 3.74609 17.0547 3.74609C16.3516 3.74609 15.7891 4.30859 15.7891 5.01172C15.7891 5.71484 16.3516 6.27734 17.0547 6.27734C17.7578 6.27734 18.3203 5.71484 18.3203 5.01172ZM21.8828 6.27734C21.7891 4.58984 21.4141 3.08984 20.1953 1.87109C18.9766 0.652344 17.4766 0.277344 15.7891 0.183594C14.0547 0.0898438 8.85156 0.0898438 7.11719 0.183594C5.42969 0.277344 3.97656 0.652344 2.71094 1.87109C1.49219 3.08984 1.11719 4.58984 1.02344 6.27734C0.929688 8.01172 0.929688 13.2148 1.02344 14.9492C1.11719 16.6367 1.49219 18.0898 2.71094 19.3555C3.97656 20.5742 5.42969 20.9492 7.11719 21.043C8.85156 21.1367 14.0547 21.1367 15.7891 21.043C17.4766 20.9492 18.9766 20.5742 20.1953 19.3555C21.4141 18.0898 21.7891 16.6367 21.8828 14.9492C21.9766 13.2148 21.9766 8.01172 21.8828 6.27734ZM19.6328 16.7773C19.3047 17.7148 18.5547 18.418 17.6641 18.793C16.2578 19.3555 12.9766 19.2148 11.4766 19.2148C9.92969 19.2148 6.64844 19.3555 5.28906 18.793C4.35156 18.418 3.64844 17.7148 3.27344 16.7773C2.71094 15.418 2.85156 12.1367 2.85156 10.5898C2.85156 9.08984 2.71094 5.80859 3.27344 4.40234C3.64844 3.51172 4.35156 2.80859 5.28906 2.43359C6.64844 1.87109 9.92969 2.01172 11.4766 2.01172C12.9766 2.01172 16.2578 1.87109 17.6641 2.43359C18.5547 2.76172 19.2578 3.51172 19.6328 4.40234C20.1953 5.80859 20.0547 9.08984 20.0547 10.5898C20.0547 12.1367 20.1953 15.418 19.6328 16.7773Z"
                  fill="#25282E"
                ></path>
              </svg>
            </div>
          </li>
        </ul>

        <label for="navToggle" className="iconBurger">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </label>
      </div>
    </>
  );
};

export default ShopHeader;
